module.exports = __webpack_public_path__ + "static/img/question4-4.2b1e2f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question4-4.png
// module id = Yqq5
// module chunks = 1